import $ from "jquery"
import request_body from './request_body';


function request(path, params, contentType) {
    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    return new Promise((resolve, reject)=>{
        let vo = {
            url: request_body.url + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                console.log(e)
                console.log('error')
                // console.log(e.responseJSON.code)
                // if (e.responseJSON.code == 403) {
                //     // if (this.app.isLogout != true) {
                //     //     this.app.isLogout = true;
                //     //     this.app.$alert('点击返回登录', '登录过期', {
                //     //         confirmButtonText: '确定',
                //     //         callback: action => {
                //     //             this.app.isLogout = false;
                //     //             this.app.$router.push("/login");
                //     //         }
                //     //     });
                //     // }
                    window.location.href = "/#/sign-in"
                // }
                reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
            vo.headers.token = request_body.token;
        }
        $.ajax(vo) 
        
    })
}

function upload(path, filePath) {
	// var url;
	// if (request_body.token == null) {
	// 	init();
	// }
	return new Promise((resolve, reject)=>{ 
		const xhr = new XMLHttpRequest()
		let fd = new FormData();
		fd.append('file', filePath)
		xhr.open('POST', request_body.url + path)
		if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
			xhr.setRequestHeader('token',request_body.token);   //设置请求头，请求头的设置必须在xhr打开之后，并且在send之前
		}
		
		xhr.send(fd)
		xhr.onreadystatechange =  () =>{
			if (xhr.readyState === 4 && xhr.status === 200) {
				//接收返回的结果并展示出来
				var data = JSON.parse(xhr.responseText)
				if (data.err === 0) {
					resolve(data)
				} else {
					reject()
				}
			}
		}
		

	})
}

export {
    request, upload
}